// IE 2026 10 04 / ODOO-345046 (заказ Игоря: одинаковая раскладка колонок в трёх видах меню)
// Единая раскладка групп по колонкам для видов панели страниц (список, дерево, плитки) — чистые функции (юнит-тест tests/unit/menuColumnsUniform.test.mjs).
// Правило одно для всех видов: K = min(число групп, floor((ширина + зазор) / (минимальная ширина колонки + зазор))); K >= число групп — каждая группа в своей колонке;
// иначе группы подряд склеиваются в K колонок (порядок сохраняется, группа целиком в одной колонке, деления на «(продолжение)» нет), границы — по равномерной
// «высоте» колонок (вес группы). Вес не зависит от вида: заголовок + число страниц верхнего уровня, поэтому состав колонок одинаков во всех видах.
import { menuPanelFit_partition } from './menuPanelFit.js'

// число колонок: groups — число групп, availW — ширина под колонки (px), minColW — минимальная ширина колонки, gap — зазор между колонками
export function menuColumns_count({ groups, availW, minColW, gap = 0 }) {
    const m = Math.max(0, Math.floor(Number(groups) || 0))
    if (!m) return 0
    const fitW = Math.floor(((Number(availW) || 0) + gap) / (Math.max(1, Number(minColW) || 1) + gap))
    return Math.max(1, Math.min(m, fitW))
}

// weights — вес каждой группы по порядку; → { k, cols: [[индексы групп]] }
export function menuColumns_layout({ weights, availW, minColW, gap = 0 }) {
    const w = Array.isArray(weights) ? weights : []
    const k = menuColumns_count({ groups: w.length, availW, minColW, gap })
    if (!k) return { k: 0, cols: [] }
    if (k >= w.length) return { k, cols: w.map((_, i) => [i]) }
    return { k, cols: menuPanelFit_partition(w.map(x => Math.max(0.1, Number(x) || 0)), k).cols }
}
